import { render } from "./ListMothersItems.vue?vue&type=template&id=23a5f43e&scoped=true"
import script from "./ListMothersItems.vue?vue&type=script&lang=js"
export * from "./ListMothersItems.vue?vue&type=script&lang=js"

import "./ListMothersItems.vue?vue&type=style&index=0&id=23a5f43e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a5f43e"]])

export default __exports__